<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form tw-pt-5 lg:tw-pt-10" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <fieldset class="tw-px-3 tw-pb-3 lg:tw-px-12 lg:tw-pb-8">
                <div v-if="step == 1">
                    <h3 class="question-title tw-py-6 lg:tw-py-8 tw-text-center">Associe cada imagem ao destino correcto</h3>
                    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-items-center tw-gap-10 tw-mx-auto">
                        <div class="option">
                            <img src="~@/assets/img/dubai.jpg" class="tw-mb-4">
                            <validation-provider class="tw-w-4/5 tw-mx-auto tw-p-0 tw-block" name="photo1" rules="required" v-slot="{ classes }">
                                <div class="input-group photo-1 less-space" :class="classes">
                                    <select id="input-photo1" placeholder=" " v-model="photo1">
                                        <option selected disabled value=" ">Destino</option>
                                        <option value="dubai">Dubai</option>
                                        <option value="tailandia">Tailândia</option>
                                        <option value="mexico">México</option>
                                    </select>
                                    <label :class="{'select-placeholder' : photo1 === ''}">
                                        Destino
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div class="option">
                            <img src="~@/assets/img/tail.jpg" class="tw-mb-4">
                            <validation-provider class="tw-w-4/5 tw-mx-auto tw-p-0 tw-block" name="photo2" rules="required" v-slot="{ classes }">
                                <div class="input-group photo-2 less-space" :class="classes">
                                    <select id="input-photo2" placeholder=" " v-model="photo2">
                                        <option selected disabled value=" ">Destino</option>
                                        <option value="dubai">Dubai</option>
                                        <option value="tailandia">Tailândia</option>
                                        <option value="mexico">México</option>
                                    </select>
                                    <label :class="{'select-placeholder' : photo2 === ''}">
                                        Destino
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div class="option">
                            <img src="~@/assets/img/mexico.jpg" class="tw-mb-4">
                            <validation-provider class="tw-w-4/5 tw-mx-auto tw-p-0 tw-block" name="photo3" rules="required" v-slot="{ classes }">
                                <div class="input-group photo-3 less-space" :class="classes">
                                    <select id="input-photo3" placeholder=" " v-model="photo3">
                                        <option selected disabled value=" ">Destino</option>
                                        <option value="dubai">Dubai</option>
                                        <option value="tailandia">Tailândia</option>
                                        <option value="mexico">México</option>
                                    </select>
                                    <label :class="{'select-placeholder' : photo3 === ''}">
                                        Destino
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                    </div>
                    <div class="tw-flex tw-items-center tw-justify-center">
                        <button :disabled="formLoading" @click.prevent="checkLocations" class="btn-next tw-uppercase tw-text-white tw-font-bold tw-mb-3 lg:tw-mb-0 tw-mx-auto tw-mt-12 lg:tw-mt-10 tw-outline-none">Participar <span></span></button>
                    </div>
                </div>

                <div v-if="step == 2">
                    <h3 class="question-title tw-py-6 lg:tw-py-8 tw-text-center">Preencha os campos com os seus dados pessoais</h3>
                    <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 lg:tw-gap-3">
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="firstName" rules="required|alpha_spaces" v-slot="{ classes }">
                                <div class="input-group input-group-name" :class="classes">
                                    <input type="text"
                                        id="input-firstName"
                                        placeholder=" "
                                        v-model="firstName"
                                    >
                                    <label>
                                        Nome
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="lastName" rules="required|alpha_spaces" v-slot="{ classes }">
                                <div class="input-group input-group-name" :class="classes">
                                    <input type="text"
                                        id="input-lastName"
                                        placeholder=" "
                                        v-model="lastName"
                                    >
                                    <label>
                                        Apelido
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="birthdate" rules="required" v-slot="{ classes }">
                                <div class="input-group input-group-birthdate" :class="classes">
                                    <input type="tel"
                                        id="input-birthdate"
                                        placeholder=" "
                                        v-model="birthdate"
                                        v-mask="{alias: 'datetime', inputFormat: 'dd-mm-yyyy', placeholder: 'DD-MM-YYYY', showMaskOnHover: false, showMaskOnFocus: true }"
                                        @blur="checkBirthdate"
                                    >
                                    <label>
                                        {{birthDateLabel}}
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                                <div class="input-group input-group-email" :class="classes">
                                    <input type="email"
                                        id="input-email"
                                        placeholder=" "
                                        v-model.lazy="email"
                                    >
                                    <label>
                                        Email {{ errors [0]}}
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes }">
                                <div class="input-group input-group-phone" :class="classes">
                                    <input type="tel"
                                        id="input-phone"
                                        placeholder=" "
                                        v-model="phone"
                                        v-mask="{mask: '999999999', placeholder: ' '}"
                                    >
                                    <label>
                                        Telefone
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="natio" rules="required" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', work: '- inválido' }">
                                <div class="input-group input-group-work" :class="classes">
                                    <select id="input-work" placeholder=" " v-model="work" @change="changeWorkLabel">
                                        <option selected disabled value=" ">Profissionalmente Activo</option>
                                        <optgroup label="----Sim:">
                                            <option value="Actor/Musico">Actor/Musico</option>
                                            <option value="Administrativo / Secretariado">Administrativo / Secretariado</option>
                                            <option value="Advogado">Advogado</option>
                                            <option value="Agricultor / Pescador">Agricultor / Pescador</option>
                                            <option value="Arquitectura / Design">Arquitectura / Design</option>
                                            <option value="Auxiliar de acção medica e acção educativa">Auxiliar de acção medica e acção educativa</option>
                                            <option value="Auxiliar Geriátrico / Saúde / Educação">Auxiliar Geriátrico / Saúde / Educação</option>
                                            <option value="Bancário">Bancário</option>
                                            <option value="Call Center / Help Desk">Call Center / Help Desk</option>
                                            <option value="Comercial / Vendas">Comercial / Vendas</option>
                                            <option value="Comerciante">Comerciante</option>
                                            <option value="Comunicação Social">Comunicação Social</option>
                                            <option value="Construção Civil">Construção Civil</option>
                                            <option value="Desporto">Desporto</option>
                                            <option value="Director / Gerente">Director / Gerente</option>
                                            <option value="Doméstica">Doméstica</option>
                                            <option value="Educação / Formação">Educação / Formação</option>
                                            <option value="Empregado balcão / Loja">Empregado balcão / Loja</option>
                                            <option value="Empregado da construção civil">Empregado da construção civil</option>
                                            <option value="Empregado de Escritório">Empregado de Escritório</option>
                                            <option value="Empregado de Hotelaria turismo e restauração">Empregado de Hotelaria turismo e restauração</option>
                                            <option value="Empregado de Limpeza">Empregado de Limpeza</option>
                                            <option value="Empresário">Empresário</option>
                                            <option value="Enfermagem">Enfermagem</option>
                                            <option value="Engenharia">Engenharia</option>
                                            <option value="Estéticista / Cabeleireiro">Estéticista / Cabeleireiro</option>
                                            <option value="Industrial">Industrial</option>
                                            <option value="Farmacêutico">Farmacêutico</option>
                                            <option value="Forças Policias, Militares e Militarizadas">Forças Policias, Militares e Militarizadas</option>
                                            <option value="Gestão de Empresas / Economia / Contabilidade">Gestão de Empresas / Economia / Contabilidade</option>
                                            <option value="Gestão RH">Gestão RH</option>
                                            <option value="Hotelaria / Turismo">Hotelaria / Turismo</option>
                                            <option value="Médico">Médico</option>
                                            <option value="Operário fabril / indústria">Operário fabril / indústria</option>
                                            <option value="Outras Profissões Liberais">Outras Profissões Liberais</option>
                                            <option value="Professor (a)">Professor (a)</option>
                                            <option value="Profissional Liberal">Profissional Liberal</option>
                                            <option value="Publicidade / Marketing / Relações Públicas">Publicidade / Marketing / Relações Públicas</option>
                                            <option value="Serviços Sociais">Serviços Sociais</option>
                                            <option value="Supervisor / Chefe de Equipa">Supervisor / Chefe de Equipa</option>
                                            <option value="Técnico de Manutenção">Técnico de Manutenção</option>
                                            <option value="Técnico Informática">Técnico Informática</option>
                                            <option value="Outra">Outra</option>
                                        </optgroup>
                                        <optgroup label="----Não:">
                                            <option value="Estudante">Estudante</option>
                                            <option value="Reformado">Reformado (até 75 anos)</option>
                                            <option value="Desempregado">Desempregado</option>
                                        </optgroup>
                                    </select>
                                    <label :class="{'select-placeholder' : work === null}">
                                        {{workLabel}} {{ errors [0]}}
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="inPortugal" rules="required" v-slot="{ classes }">
                                <div class="input-group input-group-location" :class="classes">
                                    <select id="input-formLocation" placeholder=" " v-model="inPortugal">
                                        <option selected disabled>É natural de um distrito português?</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>
                                    </select>
                                    <label :class="{'select-placeholder' : !inPortugal }">
                                        É natural de um distrito português?
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="formLocation" v-slot="{ classes }">
                                <div class="input-group input-group-location" :class="{ classes, 'disabled' : !inPortugal || inPortugal == 0 }">
                                    <select id="input-natio" placeholder=" " v-model="formLocation">
                                        <option selected disabled value=" ">Localização</option>
                                        <option v-for="district in formLocationOptions" :key="district" :value="district">{{ district }}</option>
                                        <option value="Açores">Açores</option>
                                        <option value="Madeira">Madeira</option>
                                    </select>
                                    <label :class="{'select-placeholder' : formLocation === ''}">
                                        Localização
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div>
                            <validation-provider class="tw-w-full tw-w-block" name="zip" rules="required|zip:pt" v-slot="{ classes }">
                                <div class="input-group input-group-location" :class="classes">
                                    <input type="tel"
                                        id="input-zip"
                                        placeholder=" "
                                        v-model="zip"
                                        v-mask="'9999-999'"
                                    >
                                    <label>
                                        Código Postal
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                    </div>
                    <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                        <div class="mb-2">
                            <div class="form-check tw-pt-3">
                                <label class="form-check-label" :class="classes">
                                    <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                    <span class="checkmark"></span>
                                    <!-- error color -->
                                    <span style="color: #003A63">Tomo conhecimento expresso que os meus dados pessoais são tratados de forma segura e de acordo com a legislação de proteção de dados e aceito ser contactado, tal como está descrito e indicado na <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade e consentimento de recolha de dados</u></a>. Confirmo que tenho mais de 18 anos e desejo participar neste website tendo conhecimento do seu <a href="#" @click.prevent="$store.state.modal.regulation = true"><u>regulamento</u></a>.</span>
                                </label>
                            </div>
                        </div>
                    </validation-provider>
                    <button type="submit" :disabled="formLoading" class="btn-next tw-uppercase tw-text-white tw-font-bold tw-mb-3 lg:tw-mb-0 tw-mx-auto tw-mt-12 lg:tw-mt-10">Participar <span></span></button>
                </div>


            </fieldset>
            <div class="bullets tw-flex tw-items-center tw-justify-center tw-gap-2 tw-pb-10">
                <div :class="{ 'active' : step >= 1}"></div>
                <div :class="{ 'active' : step == 2}"></div>
            </div>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/zip';

export default {
    name: 'FormComponent',
    data() {
        return {
            photo1: '',
            photo2: '',
            photo3: '',
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            zip: '',
            // reward: '',
            location: '',
            formLocation: '',
            formLocationOptions: [
                'Aveiro',
                'Beja',
                'Braga',
                'Bragança',
                'Castelo Branco',
                'Coimbra',
                'Évora',
                'Faro',
                'Distrito da Guarda',
                'Leiria',
                'Lisboa',
                'Portalegre',
                'Porto',
                'Santarém',
                'Setúbal',
                'Viana do Castelo',
                'Vila Real',
                'Viseu',
            ],
            birthdate: '',
            inPortugal: null,
            work: null,
            phrase: '',

            step: 1,
            birthYear: null,
            currentYear: new Date().getFullYear(),
            minimumAge: 27,
            maximumAge: 69,
            minimumYear: 1900,

            //*Labels*
            birthDateLabel: 'Data de nascimento',
            workLabel: 'Profissionalmente Activo',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        checkLocations() {
            const inputPhoto1 = document.querySelector('.photo-1'),
                  inputPhoto2 = document.querySelector('.photo-2'),
                  inputPhoto3 = document.querySelector('.photo-3');

            if(this.photo1 === 'dubai' && this.photo2 === 'tailandia' && this.photo3 === 'mexico') {
                this.step++;
            } else {
                if(this.photo1 != 'dubai') {
                    inputPhoto1.classList.add('has-error');
                }
                if(this.photo2 != 'tailandia') {
                    inputPhoto2.classList.add('has-error');
                }
                if(this.photo3 != 'mexico') {
                    inputPhoto3.classList.add('has-error');
                }
            }
        },
        checkBirthdate() {
            this.birthYear = parseInt(this.birthdate.split('-').pop());
        },
        changeWorkLabel() {
            this.workLabel = 'Profissionalmente Activo';
        },
        formSubmit() {
            this.formLoading = true;
            const age = parseInt(this.currentYear) - parseInt(this.birthYear);

            if(!(this.birthYear > this.minimumYear)) {
                // this.birthDateLabel = 'A sua idade não é elegível para o concurso';
                // document.querySelector('.input-group-birthdate').classList.add('has-error');
                this.$store.state.formSuccess = true;
                this.formLoading = false;
                return false;
            } else {
                this.birthDateLabel = 'Data de nascimento';
            }

            // Se tiver menos que a idade mínima, dar fake success
            if(age < this.minimumAge || age > this.maximumAge) {
                this.$store.state.formSuccess = true;
                return false;
            }

            // Se não for naturalmente de um distrito português, dar fake success
            if(this.inPortugal == '0' || this.inPortugal == 0 || this.inPortugal == null) {
                this.formLocation = '0';
                this.$store.state.formSuccess = true;
                return false;
            }

            // Se a profissão não for elegível, dar fake success
            if(this.work == 'Estudante' || this.work == 'Desempregado' || this.work == 'Reformado') {
                this.formLocation = '0';
                this.$store.state.formSuccess = true;
                return false;
            }

            let cmpInfo = {
                vendor:{
                    consents: [],
                },
                tcString: '',
            };

            try{
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                firstName: this.firstName,
                lastName: this.lastName,
                birthdate: this.birthdate,
                phone: this.phone,
                email: this.email,
                inPortugal: this.inPortugal,
                formLocation: this.formLocation,
                work: this.work,
                zip: this.zip,

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
                mclic: process.env.VUE_APP_MCLIC,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    if (error.response.data.errors.work) {
                        document.querySelector('.input-group-work').classList.add('has-error');
                        this.workLabel = 'A sua profissão não é elegível para o concurso';
                    } else {
                        this.workLabel = 'Profissionalmente Activo';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
